/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <div class="mc-form-register">
    <div class="mc-form-register-input">
      <div v-if="referral" class="referral">
        <div class="referral-img">
          <img :src="$t('Referral.' + referral + '.bannerUrl')">
        </div>
        <div>
          {{ $t('Referral.' + referral + '.text')}}
        </div>
      </div>
      <ion-item>
        <ion-label position="stacked">{{$t('Register.givenName')}} *</ion-label>
        <ion-input
          type="text"
          :placeholder="$t('Register.givenName') + '*'"
          :value="user.givenName"
          @input="user.givenName = $event.target.value;"
        ></ion-input>
      </ion-item>
      <div class="label-visible-by-all">{{$t('Register.visible-by-all')}}</div>
      <div v-if="v$.user.givenName.$error">
        <div class="mc-error-label" v-if="v$.user.givenName.required.$invalid">{{$t('Validation.required')}}</div>
      </div>

      <br />
      <ion-item>
        <ion-label position="stacked">{{$t('Register.familyName')}} *</ion-label>
        <ion-input
          type="text"
          :placeholder="$t('Register.familyName') + '*'"
          :value="user.familyName"
          @input="user.familyName = $event.target.value;"
        ></ion-input>
      </ion-item>
      <div v-if="v$.user.familyName.$error">
        <div
          class="mc-error-label"
          v-if="v$.user.familyName.required.$invalid"
        >{{$t('Validation.required')}}</div>
      </div>

      <ion-item>
        <ion-label position="stacked">{{$t('Register.email')}} *</ion-label>
        <ion-input
          type="email"
          :placeholder="$t('Register.email') + '*'"
          :value="user.email"
          @ionChange="checkedEmail = null;"
          @input="user.email = $event.target.value"
        ></ion-input>
        <ion-icon
          style="margin-top: 16px"
          slot="end"
          size="large"
          color="primary"
          class="rotating"
          v-if="this.$store.state.registerStore.statusCheckEmail == 'loading'"
          name="sync"
        ></ion-icon>
      </ion-item>
      <div v-if="v$.user.email.$error">
        <div class="mc-error-label" v-if="v$.user.email.required.$invalid">{{$t('Validation.required')}}</div>
        <div class="mc-error-label" v-if="v$.user.email.email.$invalid">{{$t('Validation.email')}}</div>
        <div class="mc-error-label" v-if="v$.user.email.checkEmail.$invalid">{{ this.$store.state.registerStore.checkEmailErrorMessage ? this.$store.state.registerStore.checkEmailErrorMessage : $t('Validation.checkEmail')}}</div>
      </div>

      <br />
      <ion-item>
        <ion-label position="stacked">{{$t('Register.password')}} *</ion-label>
        <ion-input
          type="password"
          :placeholder="$t('Register.password') + '*'"
          :value="user.password"
          @input="user.password = $event.target.value;"
        ></ion-input>
      </ion-item>
      <div v-if="v$.user.password.$error">
        <div class="mc-error-label" v-if="v$.user.password.required.$invalid">{{$t('Validation.required')}}</div>
        <div
          class="mc-error-label"
          v-if="v$.user.password.minLength.$invalid"
        >{{$t('Validation.minLength')}}</div>
        <div
          class="mc-error-label"
          v-if="v$.user.password.oneUppercase.$invalid"
        >{{$t('Validation.oneUppercase')}}</div>
        <div class="mc-error-label" v-if="v$.user.password.oneDigit.$invalid">{{$t('Validation.oneDigit')}}</div>
      </div>

      <ion-item>
        <ion-label position="stacked">{{$t('Register.confirmPassword')}} *</ion-label>
        <ion-input
          type="password"
          :placeholder="$t('Register.confirmPassword') + '*'"
          :value="user.confirmPassword"
          @input="user.confirmPassword = $event.target.value;"
        ></ion-input>
      </ion-item>
      <div v-if="v$.user.confirmPassword.$error">
        <div
          class="mc-error-label"
          v-if="v$.user.confirmPassword.required.$invalid"
        >{{$t('Validation.required')}}</div>
        <div
          class="mc-error-label"
          v-if="v$.user.confirmPassword.sameAsPassword.$invalid"
        >{{$t('Validation.sameAsPassword')}}</div>
      </div>
      <br>

      <div class="text-asterisk text-left"><small>* Champ obligatoire</small></div>
    </div>
  </div>
</template>

<style lang="scss">
.mc-form-register {
  display: block;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;

  .mc-form-register-input {
    flex: 1;
    flex-direction: column;
    display: flex;
    justify-content: center;
  }

  .label-visible-by-all {
    float: left;
    font-size: 11px;
    opacity: 0.6;
    text-align: start;
    margin-top: 3px;
  }
}

  .text-asterisk {
    font-size: 14px;
    color: rgba(0,0,0,0.4)
  }

.referral {
  border: 1px solid var(--ion-color-primary);
  border-radius: 16px;
  padding: 16px;
  margin-top: 16px;
  margin-bottom: 16px;
  font-size: 14px;
  text-align: start;
}

.referral-img {

  img {
    max-height: 100px;
    margin: auto;
    margin-bottom: 16px;
    object-fit: contain;
  }
}
</style>

<script>
import {
  required,
  email,
  sameAs,
  minLength,
  helpers
} from '@vuelidate/validators';
import useVuelidate from "@vuelidate/core";
const oneUppercase = helpers.regex(/[A-Z]/);
const oneDigit = helpers.regex(/\d/);
const { withAsync } = helpers

function checkEmailValidator (email) {
  if (!this.checkedEmail) {
    this.checkedEmail = this.$store.dispatch('checkEmail', email)
    return this.checkedEmail.then(res => {
      return res
    })
  } else {
    return this.checkedEmail.then(res => {
      return res
    })
  }
}

export default {
  name: "registerStep1",
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      checkedEmail: null,
      referral: null
    };
  },
  validations() { return {
    user: {
      givenName: {
        required
      },
      familyName: {
        required
      },
      email: {
        required,
        email,
        checkEmail: withAsync(checkEmailValidator),
      },
      password: {
        required,
        minLength: minLength(8),
        oneUppercase,
        oneDigit
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs(this.user.password)
      }
    }
    }
  },
  computed: {
    user: {
      get() {
        return this.$store.state.registerStore.userToRegister;
      },
      set() {
        this.$store.commit("register_update", this.user);
      }
    }
  },
  created() {
    const referral = this.$route.query.referral
    if (referral && this.$t('Referral.' + referral) != ('Referral.' + referral) ) {
      this.referral = referral;
    }
  },
  methods: {
    async validate() {
      await this.v$.$reset();
      await this.v$.$touch();
      await this.v$.$validate();
      if (this.v$.$invalid) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>
